// extracted by mini-css-extract-plugin
export default {"large_font":"gU"};
    if(module.hot) {
      // 1715276859554
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  